import React from 'react';
import './GoogleMapLocation.scss';
const GoogleMapLocation = () => (
	<React.Fragment>
		<div className='google-map-location-container'>
			<iframe
				allowFullScreen=''
				frameBorder='0'
				height='450'
				width='100%'
				src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d628.1146566570694!2d-1.3516884392945907!3d50.97071287310412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487473b6945ed23d%3A0x5133854a72cb5f4d!2sDocHQ!5e0!3m2!1sen!2sph!4v1573130764450!5m2!1sen!2sph'
				title='DocHQ - Interactive map'
			></iframe>
		</div>
	</React.Fragment>
);

export default GoogleMapLocation;
